import React from "react";
import {Collapse} from "antd" // TODO: custom Collapse
import styled from "styled-components"

const {Panel} = Collapse
import "antd/lib/style/index.css" // TODO: remove in the future
import "antd/lib/collapse/style/index.css" // TODO: remove in the future

export const StyledCollapse = styled((props: any) => <Collapse {...props}/>)`
  &.ant-collapse {
    border: none;
    background-color: transparent;
    width: 607px;

    & .ant-collapse-content {
      border-top: none;
      color: initial;

      .ant-collapse-content-box {
        padding: 18px 32px 32px;
      }
    }

    & .ant-collapse-item {
      margin-top: 16px;
      border: none;
      border: 2px solid #e4e5e8;
      border-radius: 4px;
      transition: 0.2s ease;

      &:hover {
        border-color: #0446ca;
      }

      & .ant-collapse-header {
        padding: 16px 32px;
      }
    }

    & .ant-collapse-item.ant-collapse-item-active {
      border-color: #1749c2;

      .collapse-icon {
        transform: rotate(180deg);

        & path {
          fill: #1749c2;
        }
      }

      & svg.code-icon path {
        stroke: #1749c2;
      }

      & svg.send-icon path {
        fill: #1749c2;
      }
    }
  }
`

export const StyledPanel = styled(Panel)``

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & div.header-content {
    display: flex;
    align-items: center;
    width: 100%;

    & svg,
    & img,
    & div {
      margin-right: 15px;
    }

    & div {
      & h3.onboarding-title {
        font-size: 16px;
        line-height: 19px;
        font-weight: 700;
      }

      & p.onboarding-subtitle {
        font-size: 14px;
        line-height: 16px;
        color: #a7a7a7;
        margin-top: 8px;
        font-weight: 400;
        text-align: left;
      }
    }
  }

  .collapse-icon {
    transition: all 0.2s ease;
    transform-origin: 50% 50%;
  }
`